module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("更多设定")]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "查看/设置关联用户"
    }
  }, [_c('cell', {
    attrs: {
      "title": _vm.displayName(_vm.user)
    }
  }, [_vm._v("\n      当前用户     \n    ")]), _vm._v(" "), _vm._l((_vm.otherUsers), function(user) {
    return _c('cell', {
      key: user.id,
      attrs: {
        "title": _vm.displayName(user),
        "is-link": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.requestToSwitch(user.id)
        }
      }
    }, [_vm._v("切换  ")])
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "设置用户",
      "is-link": "",
      "link": "/links"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../assets/users-border.svg"),
      "width": "21px"
    },
    slot: "icon"
  })])], 2), _vm._v(" "), (_vm.profile.wuid === 'GuoZhiHao') ? _c('group', {
    attrs: {
      "title": "Debug"
    }
  }, [_c('cell', {
    attrs: {
      "title": "Debug",
      "is-link": "",
      "link": "/debug"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "close-on-confirm": false,
      "title": "确定切换?"
    },
    on: {
      "on-confirm": function($event) {
        _vm.switchUser(_vm.userIdToSwitch)
      }
    },
    model: {
      value: (_vm.showConfirmSwitching),
      callback: function($$v) {
        _vm.showConfirmSwitching = $$v
      },
      expression: "showConfirmSwitching"
    }
  }, [_c('p', [_vm._v("您现在查看的是 " + _vm._s(_vm.user.data.local_name) + " 的学习情况，切换后应用将显示 " + _vm._s(_vm.userToSwitch && _vm.userToSwitch.data.local_name) + " 的学习情况")]), _vm._v(" "), _c('p', [_vm._v("如想再次切换，可以回到这里操作")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14eb26e5"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 541
// module chunks = 1